import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Environment } from 'src/app/classes/environment';
import { CustomerService } from 'src/app/services/customer.service';


@Component({
	selector: 'data-protection',
	templateUrl: './data-protection.component.html',
	styleUrls: [ './single-page.css' ],
})
export class DataProtectionComponent implements OnInit {


	bLoading = true;
	bError = false;
	legalHtml: SafeHtml = "";
	

	constructor(
		private customerService: CustomerService,
		private domSanitizer: DomSanitizer
	) {}
	
	ngOnInit(): void {
		

		this.customerService.loadLegalInformation().subscribe( data => {

			this.bLoading = false;
			this.bError = !data;
			if( data ) {
				this.legalHtml = this.domSanitizer.bypassSecurityTrustHtml( data.privacyPolicy );	
			}

		} );

	}

}
